import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {SiteModel} from '../../../../models/SiteModel';
import {SiteAnagrafService} from '../../../general-services/service-site-anagraf/site-anagraf.service';

@Component({
  selector: 'app-new-site-anagraf',
  templateUrl: './new-site-anagraf.component.html',
  styleUrls: ['./new-site-anagraf.component.scss']
})
export class NewSiteAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {
  site: SiteModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private siteService: SiteAnagrafService) {
    super();

    this.site = new SiteModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [this.site.cod, [Validators.required]],
      description: [this.site.description, [Validators.required]]
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SITE_ANAGRF]);
  }

  save(event: any, form: NgForm, clickSalva ?: boolean) {
    if (event.key === 'Enter' || clickSalva) {
      event.preventDefault();
      this.site.cod = this.formValidator.value.cod;
      this.site.description = this.formValidator.value.description;
      this.saveSubscribe = this.siteService.save(this.siteService.baseUrl, this.site).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Size Cod already exists', 'Warning');
          } else {
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SITE_ANAGRF]);
          }
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }
}
